import _ from 'lodash';

export function sendDataLayer( data = {} ) {
	if ( !_.isUndefined( window.dataLayer ) &&
		_.isArray( window.dataLayer )
	) {
		window.dataLayer.push( data );
	}
}

export default sendDataLayer;